import { http, HttpResponse } from 'msw'

interface MockCreateCardPathParams {
  alphaId: string
}

interface MockCreateCardBody {
  data: {
    creditCardName: string
    holder: string
    number: string
    expireDate: string
    brandCode: string
    description: string
    active: boolean
    companyType: 'AGENCY_CHAIN' | 'AGENCY' | 'SALES_POINT'
    shared: boolean
  }
}

export const mockCreateAgencyCard = http.post<
  MockCreateCardPathParams,
  MockCreateCardBody
>('/my-business/api/agency/v1/*/:alphaId/cards', () => {
  return HttpResponse.json(null, { status: 201 })
})
